export default __webpack_public_path__ + "static/icons.light-2bdcd80d94d5e52bae02f1f6735eb3bb.png";